export default "__VITE_ASSET__Bbe1dPCl__"